module.exports = __webpack_public_path__ + "img/ruby.0d7b113d.png";